export default __webpack_public_path__ + "static/media/logo-medium.42a25278.svg";